import React, {Component} from 'react';
import _ from 'lodash';
import Modal from 'react-modal';
import moment from 'moment';
import { toggleAdvancedModal } from '../actions';
import { connect } from 'react-redux';
import { Icon, Button, Row, Col, Input, Select, DatePicker } from 'antd';
const { RangePicker } = DatePicker;
const Option = Select.Option;
import { routeActions } from 'react-router-redux';
import createSelector from 'helpers/createSelector';
import './style.css';

const container = connect(
  createSelector(
    (state) => ({
      isOpen: _.get(state, 'advancedSearch.isOpen'),
      subjects: _.get(state, 'subject.entities'),
      sourceGroup: _.get(state, 'sourceGroup'),
      query: _.get(state, 'router.location.query'),
      me:_.get(state, 'me')
    }),
    (state) => {
      const {subjects, isOpen, sourceGroup, query, me} = state;
      const subject = subjects[me.permission.searchSubject || "56d94161a4308849680000ac"];
      const mediaTypes = _.keys(_.get(subject, 'queries'));
      return ({
        isOpen,
        mediaTypes,
        sourceGroup,
        query,
        me,
      })
    }
  )
)

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    zIndex: '999',
  },
  content: {
    position: "initial",
    width: '750px',
    border: '1px solid rgb(255, 255, 255)',
    background: '#EEEEF4',
    overflow: 'auto',
    borderRadius: '0px',
    outline: 'none',
    padding: '0px',
    margin: '50px auto',
    zIndex: '999',
  }
};
class AdvancedSearchLayout extends Component {

  state = {
    q: _.get(this.props, 'query.q', ''),
    startDate: _.get(this.props, 'query.startDate', ''),
    endDate: _.get(this.props, 'query.endDate', ''),
    from: _.get(this.props, 'query.from', []),
    sources: [],
  }

  componentWillMount() {
    this.setState({
      q: _.get(this.props, 'query.q', ''),
      startDate: _.get(this.props, 'query.startDate', undefined),
      endDate: _.get(this.props, 'query.endDate', undefined),
      from: _.get(this.props, 'query.from', [])
    })
  }

  handleModalState = () => {
    const {dispatch} = this.props;
    dispatch(toggleAdvancedModal())
  }

  //關鍵字
  handleQueryChange = (e) => {
    this.setState({
      q: e.target.value
    })
  }
  //日期
  handleDateChange = (data, dataString) => {
    this.setState({
      startDate: dataString[0] && dataString[0],
      endDate: dataString[1] && dataString[1]
    })
  }
  //媒體選擇
  handleMediaTypeChange = (value) => {
    const zoom = this.state.mediaType == value ? this.state.zoom : "";
    const sourceGroupData = this.state.mediaType == value ? this.state.zoom : {};
    this.setState({
      mediaType: value,
      zoom,
      sourceGroupData
    })
  }
  //地區選擇
  handleZoomChange = (value) => {
    const {sourceGroup} = this.props;
    const sourceGroupData = _.get(sourceGroup, `entities[${this.state.mediaType}][${value}]`)
    const sources = _.take(_.get(sourceGroupData, 'sources'), 100);
    this.setState({
      zoom: value,
      sourceGroupData,
      sources
    })
  }
  //篩選媒體來源
  handleSearchFromInputChange = (value) => {
    let sources = [...this.state.sources];
    if (!_.isEmpty(value.trim())) {
      sources = _.flatMap(_.get(this.state.sourceGroupData, 'sources'), (source) => {
        if (_.includes(this.state.from, source)) {
          return source;
        } else {
          if (_.includes(source, value)) {
            return source;
          } else {
            return [];
          }
        }
      })
    } else {
      let index = 1;
      sources = _.flatMap(_.get(this.state.sourceGroupData, 'sources'), (source, i) => {
        if (_.includes(this.state.from, source)) {
          index++;
          return source;
        } else {
          if (index < 100) {
            index++;
            return source;
          } else {
            return []
          }
        }
      })
    }
    this.setState({
      sources
    })
  }
  handleSearchFromChange = (value) => {
    this.setState({
      from: value
    })
  }

  //搜索
  onSearch = () => {
    const {dispatch, me} = this.props;
    const fetchQuery = {
      subjectId: me.permission.searchSubject || "56d94161a4308849680000ac",
      q: this.state.q,
      sourceGroupId: _.get(this.state, 'sourceGroupData.id'),
      mediaType: this.state.mediaType,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      from: this.state.from,
    }
    dispatch(toggleAdvancedModal())
      .then(() => {
        dispatch(routeActions.push({
          pathname: '/search',
          query: fetchQuery
        }))
      })
  }

  render() {
    const {isOpen, sourceGroup, mediaTypes} = this.props;
    const zooms = sourceGroup[this.state.mediaType];
    const startDate = this.state.startDate && moment(this.state.startDate).format('YYYY-MM-DD HH:mm:ss');
    const endDate = this.state.endDate && moment(this.state.endDate).format('YYYY-MM-DD HH:mm:ss');
    // console.log(this.state.startDate, this.state.endDate)
    return (
      <Modal
        isOpen={isOpen}
        closeTimeoutMS={150}
        style={styles}
        onRequestClose={() => this.handleModalState()}
      >
        <div className="margin-md">
          <div className="advanced-search-input">
            <Row className="padding-bottom-md">
              <Col span="4">
                <div className="search-title">關鍵字：</div>
              </Col>
              <Col span="20">
                <Input size="large" placeholder="可支持 AND/OR/NOT 組合關鍵字" value={this.state.q} onChange={this.handleQueryChange} />
              </Col>
            </Row>
            <Row className="padding-bottom-md">
              <Col span="4">
                <div className="search-title">時間：</div>
              </Col>
              <Col span="20">
                <RangePicker
                  showTime={{ format: 'HH:mm' }}
                  format="yyyy-MM-dd HH:mm"
                  value={[startDate, endDate]}
                  placeholder={['開始時間', '結束時間']}
                  onChange={this.handleDateChange}
                />
              </Col>
            </Row>
            <Row className="padding-bottom-md">
              <Col span="4">
                <div className="search-title">媒體來源：</div>
              </Col>
              <Col span="10">
                <Select value={this.state.mediaType} placeholder="媒體類型" style={{ width: "90%" }} onChange={this.handleMediaTypeChange}>
                  {_.map(mediaTypes, (mediaType) => 
                    <Option value={mediaType} key={mediaType}>{t(mediaType)}</Option>
                  )}
                </Select>
              </Col>
              <Col span="10">
                <Select value={this.state.zoom} placeholder="媒體分類" style={{ width: "100%" }} onChange={this.handleZoomChange}>
                  {_.map(zooms, (zoom) => 
                    <Option value={zoom} key={zoom}>{zoom}</Option>
                  )}
                </Select>
              </Col>
            </Row>
          </div>
          {!_.isEmpty(this.state.sourceGroupData) &&
            <Row className="padding-bottom-md advan-from">
              <Col span="20" offset="4">
                <Select
                  multiple={true}
                  style={{ width: '100%' }}
                  value={this.state.from}
                  placeholder="輸入媒體關鍵字過濾"
                  onChange={this.handleSearchFromChange}
                  onSearch={this.handleSearchFromInputChange}
                >
                  {_.map(_.uniq(this.state.sources), (source, i) =>
                    <Option value={source} key={i}>{source}</Option>
                  )}
                </Select>
              </Col>
            </Row>
          }
          <div className="advanced-footer">
            <Button size="large" onClick={this.handleModalState}>關閉</Button>
            <Button size="large" type="primary" className="pull-right" onClick={this.onSearch}>搜索</Button>
          </div>
        </div>
      </Modal>
    )
  }
}


export default container(AdvancedSearchLayout)



/** WEBPACK FOOTER **
 ** ./src/app/modules/advancedSearch/components/AdvancedSearchLayout.js
 **/